import { render, staticRenderFns } from "./act004-quiz-question.vue?vue&type=template&id=4e88323d&scoped=true"
import script from "./act004-quiz-question.vue?vue&type=script&lang=js"
export * from "./act004-quiz-question.vue?vue&type=script&lang=js"
import style0 from "./act004-quiz-question.vue?vue&type=style&index=0&id=4e88323d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88323d",
  null
  
)

export default component.exports